/**
 * Read a File/Blob as a data: URL.
 * Prefer this over URL.createObjectURL for crop/preview UIs — production CSP
 * (Helmet + nginx) often allows data: but blocks blob: images.
 */
export function fileToDataUrl(file: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result === 'string' && result.startsWith('data:')) {
        resolve(result);
        return;
      }
      reject(new Error('Could not read image as data URL'));
    };
    reader.onerror = () => reject(new Error('Could not read image file'));
    reader.readAsDataURL(file);
  });
}
